import React from 'react';
export class CnListProItemAction extends React.Component {
    render() {
        return <>{this.props.children}</>;
    }
}
CnListProItemAction.displayName = 'CnListProItemAction';
